import * as angular from 'angular';
import SetupFeaturesBridge from './SetupFeaturesBridge';
angular
  .module('flowingly.runner.setup')
  .component('setupFeatures', SetupFeaturesBridge);
